import useSWR from 'swr';
import { BalanceResponse } from '../types/Usage';
import api from '../utils/api';

export const useAccountBalance = () => {
  const { data, error, isLoading } = useSWR<{ data: BalanceResponse }>(
    '/subscriptions/v1/credits/me/balance',
    api,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      shouldRetryOnError: true,
      refreshInterval: 0,
      dedupingInterval: 5000 // Prevent repeated calls within 5 seconds
    }
  );

  return {
    data: data?.data,
    isLoading,
    isError: !!error
  };
};
